import { MdArrowBack } from "react-icons/md";
import { UtilityContext } from "../../context/util-context";
import { useContext } from "react";

export default function Heading({ title, children, description, isBackArrow = false }) {
  const { goBack } = useContext(UtilityContext);
  
  return (
    <div className="grid items-center gap-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {isBackArrow && (
            <MdArrowBack onClick={goBack} className="hidden text-2xl icon lg:block" />
          )}
          <p data-tour={title} className="text-lg font-semibold text-white">{title}</p>
        </div>
        <div className="flex items-center space-x-6">{children}</div>
      </div>
      <hr className="hr" />
      <p className="text-xs text-stone-400">{description}</p>
    </div>
  );
}
